module.exports = __webpack_public_path__ + "media/ice_shopper_lifetime_metrics/vol-on-b25d87b2.svg";